import { Component} from '@angular/core';

@Component({
    selector: 'registrationEvent-main',
    templateUrl: './registrationEvent-main.tmpl.html'
})

export class RegistrationEventMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  